module.exports = __webpack_public_path__ + "img/notStarted.ce9d1c53.svg";